import SlideFrame from "./_SlideFrame";

export default function SlideTraction() {
  return (
    <SlideFrame tag="05 · Proof">
      <p className="overline mb-6">IBA Servicing traction to date</p>
      <h2 className="font-display text-5xl md:text-6xl tracking-tighter leading-[0.95] font-medium max-w-4xl">
        Real platform volume. Real operators. <em className="italic">Not a prototype.</em>
      </h2>

      <div className="mt-14 grid md:grid-cols-2 gap-px bg-foreground/20 border border-foreground/20">
        <div className="bg-background p-10 md:p-14">
          <p className="overline mb-6">Installment plans processed</p>
          <p className="font-mono-data text-6xl md:text-7xl lg:text-[7rem] leading-none tracking-tighter break-words">60K+</p>
          <p className="mt-6 text-muted-foreground">Across consumer installment & RISC.</p>
        </div>
        <div className="bg-background p-10 md:p-14 border-t-4 border-t-primary">
          <p className="overline mb-6">Volume serviced</p>
          <p className="font-mono-data text-6xl md:text-7xl lg:text-[7rem] leading-none tracking-tighter text-foreground break-words">$234M+</p>
          <p className="mt-6 text-muted-foreground">In aggregate loan volume to date.</p>
        </div>
      </div>
    </SlideFrame>
  );
}
